import { render } from "./ProductsCenter.vue?vue&type=template&id=946ecfe0&scoped=true"
import script from "./ProductsCenter.vue?vue&type=script&lang=js"
export * from "./ProductsCenter.vue?vue&type=script&lang=js"

import "./ProductsCenter.vue?vue&type=style&index=0&id=946ecfe0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-946ecfe0"]])

export default __exports__